import jobManagementService from '@/api/job-management.service'

const actions = {
  getActiveList(context) {
    var promise = new Promise((resolve, reject) => {
      jobManagementService
        .getActiveList(context)
        .then(response => {
          // context.commit('activeProd', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  getInactiveList(context) {
    var promise = new Promise((resolve, reject) => {
      jobManagementService
        .getInactiveList(context)
        .then(response => {
          // context.commit('inactiveProd', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  getExpiredList(context) {
    var promise = new Promise((resolve, reject) => {
      jobManagementService
        .getExpiredList(context)
        .then(response => {
          // context.commit('expiredProd', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },

  selectJobForEdit(context) {}
}

export default actions
